import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import IconButton from "@material-ui/core/IconButton";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { Typography, InputLabel } from "@material-ui/core";
import { setStudentCategories } from "../firebaseApi";
const DEVMODE = true;
const styles = (theme) => ({});

function StudentLocked(props) {

    const handleExit = ()=>{
        handleClose()
    }
    const handleClose = (event, reason) => {
		if (reason === "backdropClick") {
			return;
		}
		props.openCtl(false);
	};
	return (
		<>
	
				<Dialog fullWidth maxWidth="sm" open={props.open} onClose={handleClose}>
					<DialogTitle>{"Your account has been locked!"}</DialogTitle>

					<DialogContent>
						<Typography>
						You can continue voting for now, but you need to see the instructor by the end of the lecture to unlock your account. 
						This is important and may otherwise jeopardise your standing in the course. If you have been unlocked and are still seeing 
						this message, please reload the page.
                        </Typography>
					</DialogContent>
                    <DialogActions>
						<Button color="primary" onClick={handleExit}>
							Ok
						</Button>
                </DialogActions>
				</Dialog>
               
			
		</>
	);
}

const mapStateToProps = (state) => {
	return state;
};

const mapDispatchToProps = (dispatch) => {
	return {};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(withStyles(styles, { withTheme: true })(withWidth()(StudentLocked))));
